import type { ComponentProps } from 'react';
import { Button } from '../../ui/button';

function ControlButton(props: ComponentProps<typeof Button>) {
  return (
    <Button
      variant="secondary"
      size="lg"
      className="w-18"
      {...props}
    />
  );
}

export default ControlButton;
